module.exports = __webpack_public_path__ + "dashboard/img/puzzle.078a0b516f8d73302b5e680e89bf17ff.svg";